import { authHeader } from "./auth";
import { wrapRequest } from "./nav";
import { wrapGqlRequest } from "../services/graphqlEndPointCommonSetting/wrapGqlRequest";
const vueAppMagenotApiUrl = import.meta.env.VITE_MAGENTO_API_URL;
const vueAppNodeslsApiUrl = import.meta.env.VITE_NODESLS_API_URL;
const assetNodeslsUrl = import.meta.env.VITE_ASSETS_NODESLS_URL;
const retailorId = import.meta.env.VITE_RETAILOR_ID;

// export const doPostCartItem = wrapRequest((sku, qty, ccid, price, personalizeDetails,builderId, quoteId, optionId, optionValue) => {
//     const requestOptions = {
//         method: 'POST',
//         headers: {
//             'Content-type': 'application/json',
//             'Access-Control-Allow-Origin': '*',
//             ...authHeader()
//         },
//         body: JSON.stringify({
//             "cartItem": {
//                 "quote_id": quoteId,
//                 "sku": sku,
//                 "qty": qty,
//                 "product_option": {"extension_attributes": {"custom_options": [{ option_id: optionId, option_value: optionValue }]}}
//             },
//             "ccid": ccid,
//             "order_total": price,
//             "personalize_Data": personalizeDetails,
//             "builder_id": builderId,
//         })
//     };
//     return fetch(`${vueAppMagenotApiUrl}/rest/V1/carts/mine/items`, requestOptions)
// });
export const doPostCartItem = async (
  sku,
  qty,
  ccid,
  price,
  personalizeDetails,
  builderId,
  quoteId,
  optionId,
  optionValue,
) => {
  const query = `mutation AddProductsToCart($cartId: String!, $cartItems: [CartItemInput!]!) {
  addProductsToCart(cartId: $cartId, cartItems: $cartItems) {
    cart {
      ...CART_FRAGMENT
    }
    user_errors {
      code
      message
    }
  }
}
 fragment CART_FRAGMENT on Cart {
  id
  total_quantity
  is_virtual
  itemsV2 {
    items {
      ...CART_ITEM_FRAGMENT
    }
  }
}

fragment CART_ITEM_FRAGMENT on CartItemInterface {
  __typename
  uid
  quantity
  is_available
  not_available_message
  errors {
    code
    message
  }
  prices {
    price {
      value
      currency
    }
  }
  product {
    name
    sku
    quantity
    stock_status
  }
}
`;
  const variables = {
    cartId: quoteId,
    cartItems: [
      {
        sku: sku,
        quantity: qty,
      },
    ],
  };
  const response = await wrapGqlRequest(query, variables, "addProductsToCart");
  return response?.cart ?? {};
};

export const doPostConfiguredCartItem = async (
  itemNumber,
  quantity,
  typeId,
  optionId,
  optionValue,
  quoteId,
) => {
  console.log("Calling doPostConfiguredCartItem");
  console.log(
    `${itemNumber},${quantity},${typeId},${optionId},${optionValue},${quoteId}`,
  );
  optionId = btoa(`configurable/${optionId}/${optionValue}`);
  const mutation = addToCartRequestMutation();
  const variables = {
    cartId: quoteId,
    cartItems: [
      {
        sku: itemNumber,
        quantity: quantity,
        selected_options: optionValue ? [optionValue] : undefined,
      },
    ],
  };

  const response = await wrapGqlRequest(
    mutation,
    variables,
    "addProductsToCart",
  );
  return response?.cart;
};

export const doPutConfiguredCartItem = async (
  sku,
  qty,
  quoteId,
  itemId,
  optionId,
  optionValue,
) => {
  console.log("Calling doPutConfiguredCartItem");
  console.log(sku, qty, quoteId, itemId, optionId, optionValue);
  optionId = btoa(`configurable/${optionId}/${optionValue}`);
  const res = await doDeleteCartProduct(itemId, quoteId);
  if (!res) throw new Error("Unable to Update the Cart");
  const mutation = addToCartRequestMutation();
  const variables = {
    cartId: quoteId,
    cartItems: [
      {
        sku: sku,
        quantity: qty,
        selected_options: optionValue ? [optionValue] : undefined,
      },
    ],
  };
  const response = await wrapGqlRequest(
    mutation,
    variables,
    "addProductsToCart",
  );
  return response?.cart;
};

export const doPostGiftCartItem = async (data, quoteId, giftCartDetails) => {
  const query = addGiftCardToCartRequestMutation();
  const variables = {
    cartId: quoteId,
    cartItems: [
      {
        sku: data?.sku,
        quantity: parseFloat(data?.qty) ?? 0.0,
        entered_options: [
          {
            uid: "Z2lmdGNhcmQvZ2lmdGNhcmRfbWVzc2FnZQ==",
            value: giftCartDetails?.senderMessage,
          },
          {
            uid: "Z2lmdGNhcmQvZ2lmdGNhcmRfc2VuZGVyX25hbWU=",
            value: data?.senderName,
          },
          {
            uid: "Z2lmdGNhcmQvZ2lmdGNhcmRfc2VuZGVyX2VtYWls",
            value: data?.senderEmail,
          },
          {
            uid: "Z2lmdGNhcmQvZ2lmdGNhcmRfcmVjaXBpZW50X25hbWU=",
            value: giftCartDetails?.recipientName,
          },
          {
            uid: "Z2lmdGNhcmQvZ2lmdGNhcmRfcmVjaXBpZW50X2VtYWls",
            value: giftCartDetails?.recipientEmail,
          },
          {
            uid: "Z2lmdGNhcmQvZ2lmdGNhcmRfYW1vdW50",
            value: giftCartDetails?.giftCardAmt,
          },
        ],
      },
    ],
  };
  const response = await wrapGqlRequest(query, variables, "addProductsToCart");
  return response?.cart ?? {};
};

export const doPutGiftCartItem = async (data, quoteId, giftCartDetails) => {
  const result = await doDeleteCartProduct(data?.itemId, quoteId);
  if (!result) throw new Error("Unable to Update the Cart");
  const query = addGiftCardToCartRequestMutation();
  const variables = {
    cartId: quoteId,
    cartItems: [
      {
        sku: data?.sku,
        quantity: parseFloat(data?.qty) ?? 0.0,
        entered_options: [
          {
            uid: "Z2lmdGNhcmQvZ2lmdGNhcmRfbWVzc2FnZQ==",
            value: giftCartDetails.senderMessage,
          },
          {
            uid: "Z2lmdGNhcmQvZ2lmdGNhcmRfc2VuZGVyX25hbWU=",
            value: data?.senderName,
          },
          {
            uid: "Z2lmdGNhcmQvZ2lmdGNhcmRfc2VuZGVyX2VtYWls",
            value: data.senderEmail,
          },
          {
            uid: "Z2lmdGNhcmQvZ2lmdGNhcmRfcmVjaXBpZW50X25hbWU=",
            value: giftCartDetails.recipientName,
          },
          {
            uid: "Z2lmdGNhcmQvZ2lmdGNhcmRfcmVjaXBpZW50X2VtYWls",
            value: giftCartDetails?.recipientEmail,
          },
          {
            uid: "Z2lmdGNhcmQvZ2lmdGNhcmRfYW1vdW50",
            value: giftCartDetails.giftCardAmt,
          },
        ],
      },
    ],
  };

  const response = await wrapGqlRequest(query, variables, "addProductsToCart");
  return response?.cart ?? {};
};

// export const doFetchQuote = wrapRequest(() => {
//     const requestOptions = {
//         method: 'POST',
//         headers: {
//             'Content-type': 'application/json',
//             'Access-Control-Allow-Origin': '*',
//             ...authHeader()
//         }
//     };

//     return fetch(`${vueAppMagenotApiUrl}/rest/V1/carts/mine`, requestOptions)

// });
export const doFetchQuote = async () => {
  const query = `
        {
            customerCart {
                id
            }
        }    
    `;
  const response = await wrapGqlRequest(query, {}, "customerCart");
  console.log("doFetchQuoteLoggedin", response);
  return response?.id ?? "";
};

// export const doFetchCartId = wrapRequest(() => {
//     const requestOptions = {
//         method: 'GET',
//         headers: {
//             'Content-type': 'application/json',
//             'Access-Control-Allow-Origin': '*',
//             ...authHeader()
//         }
//     };
//     return fetch(`${vueAppMagenotApiUrl}/rest/V1/carts/mine`, requestOptions)
// });
export const doFetchCartId = async (quoteId) => {
  let query = `
    query FetchCart($cartId: String!) {
        cart(cart_id: $cartId) {
            ...CART_FRAGMENT
        }
    }
    fragment CART_FRAGMENT on Cart {
      id
      total_quantity
      is_virtual
      applied_gift_cards {
        ...APPLIED_GIFT_CARDS_FRAGMENT
      }
      gift_receipt_included
      printed_card_included
      gift_message {
        ...GIFT_MESSAGE_FRAGMENT
      }
      gift_wrapping {
        ...GIFT_WRAPPING_FRAGMENT
      }
      available_gift_wrappings {
        ...AVAILABLE_GIFT_WRAPPING_FRAGMENT
      }
          applied_store_credit {
    applied_balance {
        currency
        value
    }
    current_balance {
        currency
        value
    }
    enabled
  }
      prices {
        gift_options {
          gift_wrapping_for_items {
            currency
            value
          }
          gift_wrapping_for_items_incl_tax {
            currency
            value
          }
          gift_wrapping_for_order {
            currency
            value
          }
          gift_wrapping_for_order_incl_tax {
            currency
            value
          }
          printed_card {
            currency
            value
          }
          printed_card_incl_tax {
            currency
            value
          }
        }
        subtotal_with_discount_excluding_tax {
          currency
          value
        }
        subtotal_including_tax {
          currency
          value
        }
        subtotal_excluding_tax {
          currency
          value
        }
        grand_total {
          currency
          value
        }
        grand_total_excluding_tax {
          currency
          value
        }
        applied_taxes {
          label
          amount {
            value
            currency
          }
        }
        discounts {
          amount {
            value
            currency
          }
          label
          coupon {
            code
          }
          applied_to
        }
      }
      applied_coupons {
        code
      }
      itemsV2 {
        items {
          ...CART_ITEM_FRAGMENT
        }
      }
      shipping_addresses {
        selected_shipping_method{
          carrier_code
          carrier_title
          method_code
          method_title
          amount{
            value
            currency
          }
        }
        country {
          code
        }
        region {
          code
        }
        postcode
      }
    }

    fragment CART_ITEM_FRAGMENT on CartItemInterface {
      __typename
      uid
      quantity
      is_available
      not_available_message
      errors {
        code
        message
      }
      prices {
        price {
          value
          currency
        }
        discounts {
          amount {
            value
            currency
          }
          label
        }
        total_item_discount {
          value
          currency
        }
        row_total {
          value
          currency
        }
        row_total_including_tax {
          value
          currency
        }
        price_including_tax {
          value
          currency
        }
        fixed_product_taxes {
          amount {
            value
            currency
          }
          label
        }
        original_item_price {
          value
          currency
        }
        original_row_total {
          value
          currency
        }
      }
      product {
        name
        sku
        quantity
        __typename
        gift_message_available
        gift_wrapping_available
        gift_wrapping_price {
          currency
          value
        }
        thumbnail {
          url
          label
        }

        url_key
        canonical_url
        categories {
          url_path
          url_key
          name
        }
        custom_attributesV2 {
          items {
            code
            ... on AttributeValue {
              value
            }
            ... on AttributeSelectedOptions {
              selected_options {
                value
                label
              }
            }
          }
        }
        only_x_left_in_stock
        stock_status
        price_range {
          ...PRICE_RANGE_FRAGMENT
        }
        crosssell_products {
          __typename
          min_sale_qty
          name
          stock_status
          quantity
          sku
          special_price
          special_to_date
          stock_status
          image {
            url
            label
          }
          uid
          url_key
          custom_attributesV2 {
            items {
              code
              ... on AttributeValue {
                value
              }
              ... on AttributeSelectedOptions {
                selected_options {
                  value
                  label
                }
              }
            }
          }
        }
      }

      ... on SimpleCartItem {
        available_gift_wrapping {
          ...AVAILABLE_GIFT_WRAPPING_FRAGMENT
        }
        gift_message {
          ...GIFT_MESSAGE_FRAGMENT
        }
        gift_wrapping {
          ...GIFT_WRAPPING_FRAGMENT
        }
        customizable_options {
          ...CUSTOMIZABLE_OPTIONS_FRAGMENT
        }
      }

      ... on ConfigurableCartItem {
        available_gift_wrapping {
          ...AVAILABLE_GIFT_WRAPPING_FRAGMENT
        }
        gift_message {
          ...GIFT_MESSAGE_FRAGMENT
        }
        gift_wrapping {
          ...GIFT_WRAPPING_FRAGMENT
        }
        configurable_options {
          configurable_product_option_uid
          option_label
          value_label
          configurable_product_option_value_uid
        }
        configured_variant {
          uid
          sku
          only_x_left_in_stock
          stock_status
          thumbnail {
            label
            url
          }
          price_range {
            ...PRICE_RANGE_FRAGMENT
          }
        }
        customizable_options {
          ...CUSTOMIZABLE_OPTIONS_FRAGMENT
        }
      }

      ... on BundleCartItem {
        available_gift_wrapping {
          ...AVAILABLE_GIFT_WRAPPING_FRAGMENT
        }
        gift_message {
          ...GIFT_MESSAGE_FRAGMENT
        }
        gift_wrapping {
          ...GIFT_WRAPPING_FRAGMENT
        }
        bundle_options {
          uid
          label
          values {
            uid
            label
          }
        }
      }

      ... on GiftCardCartItem {
        message
        recipient_email
        recipient_name
        sender_email
        sender_name
        amount {
          currency
          value
        }
        is_available
      }
    }

    fragment PRICE_RANGE_FRAGMENT on PriceRange {
      minimum_price {
        regular_price {
          value
          currency
        }
        final_price {
          value
          currency
        }
        discount {
          percent_off
          amount_off
        }
      }
      maximum_price {
        regular_price {
          value
          currency
        }
        final_price {
          value
          currency
        }
        discount {
          percent_off
          amount_off
        }
      }
    }

    fragment CUSTOMIZABLE_OPTIONS_FRAGMENT on SelectedCustomizableOption {
      type
      customizable_option_uid
      label
      is_required
      values {
        label
        value
        price {
          type
          units
          value
        }
      }
    }

    fragment GIFT_WRAPPING_FRAGMENT on GiftWrapping {
      __typename
      uid
      design
      image {
        url
      }
      price {
        value
        currency
      }
    }

    fragment GIFT_MESSAGE_FRAGMENT on GiftMessage {
      __typename
      from
      to
      message
    }

    fragment AVAILABLE_GIFT_WRAPPING_FRAGMENT on GiftWrapping {
      __typename
      uid
      design
      image {
        url
        label
      }
      price {
        currency
        value
      }
    }

    fragment APPLIED_GIFT_CARDS_FRAGMENT on AppliedGiftCard {
      __typename
      code
      applied_balance {
        value
        currency
      }
      current_balance {
        value
        currency
      }
      expiration_date
    }
  `;
  const variables = { cartId: quoteId };
  const cart = await wrapGqlRequest(query, variables, "cart");
  return cart;
};


export const doFetchCartProducts = async (userCartId) => {
  let query = `
    query FetchCart($cartId: String!) {
        cart(cart_id: $cartId) {
            ...CART_FRAGMENT
        }
    }
    fragment CART_FRAGMENT on Cart {
      id
      total_quantity
      is_virtual
      applied_gift_cards {
        ...APPLIED_GIFT_CARDS_FRAGMENT
      }
          applied_store_credit {
    applied_balance {
        currency
        value
    }
    current_balance {
        currency
        value
    }
    enabled
  }
      gift_receipt_included
      printed_card_included
      gift_message {
        ...GIFT_MESSAGE_FRAGMENT
      }
      gift_wrapping {
        ...GIFT_WRAPPING_FRAGMENT
      }
      available_gift_wrappings {
        ...AVAILABLE_GIFT_WRAPPING_FRAGMENT
      }
      prices {
        gift_options {
          gift_wrapping_for_items {
            currency
            value
          }
          gift_wrapping_for_items_incl_tax {
            currency
            value
          }
          gift_wrapping_for_order {
            currency
            value
          }
          gift_wrapping_for_order_incl_tax {
            currency
            value
          }
          printed_card {
            currency
            value
          }
          printed_card_incl_tax {
            currency
            value
          }
        }
        subtotal_with_discount_excluding_tax {
          currency
          value
        }
        subtotal_including_tax {
          currency
          value
        }
        subtotal_excluding_tax {
          currency
          value
        }
        grand_total {
          currency
          value
        }
        grand_total_excluding_tax {
          currency
          value
        }
        applied_taxes {
          label
          amount {
            value
            currency
          }
        }
        discounts {
          amount {
            value
            currency
          }
          label
          coupon {
            code
          }
          applied_to
        }
      }
      applied_coupons {
        code
      }
      itemsV2 {
        items {
          ...CART_ITEM_FRAGMENT
        }
      }
      shipping_addresses {
        selected_shipping_method{
          carrier_code
          carrier_title
          method_code
          method_title
          amount{
            value
            currency
          }
        }
        country {
          code
        }
        region {
          code
        }
        postcode
      }
    }

    fragment CART_ITEM_FRAGMENT on CartItemInterface {
      __typename
      uid
      quantity
      is_available
      not_available_message
      errors {
        code
        message
      }
      prices {
        price {
          value
          currency
        }
        discounts {
          amount {
            value
            currency
          }
          label
        }
        total_item_discount {
          value
          currency
        }
        row_total {
          value
          currency
        }
        row_total_including_tax {
          value
          currency
        }
        price_including_tax {
          value
          currency
        }
        fixed_product_taxes {
          amount {
            value
            currency
          }
          label
        }
        original_item_price {
          value
          currency
        }
        original_row_total {
          value
          currency
        }
      }
      product {
        name
        sku
        quantity
        __typename
        gift_message_available
        gift_wrapping_available
        gift_wrapping_price {
          currency
          value
        }
        thumbnail {
          url
          label
        }

        url_key
        canonical_url
        categories {
          url_path
          url_key
          name
        }
           custom_attributesV2 {
            items {
               code
               ... on AttributeValue {
                  value
               }
              ... on AttributeSelectedOptions {
                 selected_options {
                   value
                  label
                 }
               }
              }
            }
        only_x_left_in_stock
        stock_status
        price_range {
          ...PRICE_RANGE_FRAGMENT
        }
        crosssell_products {
          __typename
          min_sale_qty
          name
          stock_status
          quantity
          sku
          special_price
          special_to_date
          stock_status
          image {
            url
            label
          }
          uid
          url_key
          #  custom_attributesV2 {
          #    items {
          #      code
          #      ... on AttributeValue {
          #        value
          #      }
          # #     ... on AttributeSelectedOptions {
          # #       selected_options {
          # #         value
          # #         label
          # #       }
          # #     }
          #    }
          #  }
        }
      }

      ... on SimpleCartItem {
        available_gift_wrapping {
          ...AVAILABLE_GIFT_WRAPPING_FRAGMENT
        }
        gift_message {
          ...GIFT_MESSAGE_FRAGMENT
        }
        gift_wrapping {
          ...GIFT_WRAPPING_FRAGMENT
        }
        customizable_options {
          ...CUSTOMIZABLE_OPTIONS_FRAGMENT
        }
      }

      ... on ConfigurableCartItem {
        available_gift_wrapping {
          ...AVAILABLE_GIFT_WRAPPING_FRAGMENT
        }
        gift_message {
          ...GIFT_MESSAGE_FRAGMENT
        }
        gift_wrapping {
          ...GIFT_WRAPPING_FRAGMENT
        }
        configurable_options {
          configurable_product_option_uid
          option_label
          value_label
          configurable_product_option_value_uid
        }
        configured_variant {
          uid
          sku
          only_x_left_in_stock
          stock_status
          thumbnail {
            label
            url
          }
          price_range {
            ...PRICE_RANGE_FRAGMENT
          }
        }
        customizable_options {
          ...CUSTOMIZABLE_OPTIONS_FRAGMENT
        }
      }

      ... on BundleCartItem {
        available_gift_wrapping {
          ...AVAILABLE_GIFT_WRAPPING_FRAGMENT
        }
        gift_message {
          ...GIFT_MESSAGE_FRAGMENT
        }
        gift_wrapping {
          ...GIFT_WRAPPING_FRAGMENT
        }
        bundle_options {
          uid
          label
          values {
            uid
            label
          }
        }
      }

      ... on GiftCardCartItem {
        message
        recipient_email
        recipient_name
        sender_email
        sender_name
        amount {
          currency
          value
        }
        is_available
      }
    }

    fragment PRICE_RANGE_FRAGMENT on PriceRange {
      minimum_price {
        regular_price {
          value
          currency
        }
        final_price {
          value
          currency
        }
        discount {
          percent_off
          amount_off
        }
      }
      maximum_price {
        regular_price {
          value
          currency
        }
        final_price {
          value
          currency
        }
        discount {
          percent_off
          amount_off
        }
      }
    }

    fragment CUSTOMIZABLE_OPTIONS_FRAGMENT on SelectedCustomizableOption {
      type
      customizable_option_uid
      label
      is_required
      values {
        label
        value
        price {
          type
          units
          value
        }
      }
    }

    fragment GIFT_WRAPPING_FRAGMENT on GiftWrapping {
      __typename
      uid
      design
      image {
        url
      }
      price {
        value
        currency
      }
    }

    fragment GIFT_MESSAGE_FRAGMENT on GiftMessage {
      __typename
      from
      to
      message
    }

    fragment AVAILABLE_GIFT_WRAPPING_FRAGMENT on GiftWrapping {
      __typename
      uid
      design
      image {
        url
        label
      }
      price {
        currency
        value
      }
    }

    fragment APPLIED_GIFT_CARDS_FRAGMENT on AppliedGiftCard {
      __typename
      code
      applied_balance {
        value
        currency
      }
      current_balance {
        value
        currency
      }
      expiration_date
    }
  `;
  const variables = {
    cartId: userCartId,
  };
  const response = await wrapGqlRequest(query, variables, "cart");

  const cart = response || {};
  const prices = cart.prices || {};
  const shippingAddress = cart.shipping_addresses
    ? cart.shipping_addresses[0]
    : {};

  const totals = {
    grand_total: prices.grand_total?.value || 0,
    subtotal_excluding_tax: prices.subtotal_excluding_tax?.value || 0,
    subtotal_including_tax: prices.subtotal_including_tax?.value || 0,
    applied_taxes: (prices.applied_taxes || []).map((tax) => ({
      label: tax.label,
      amount: tax.amount?.value || 0,
    })),
    discounts: (prices.discounts || []).map((discount) => ({
      label: discount.label,
      amount: discount.amount?.value || 0,
    })),
    currency: prices.grand_total?.currency || "USD",
    shipping:
      shippingAddress?.selected_shipping_method?.amount?.value ?? 0,
    totalTax: (prices.applied_taxes || []).reduce(
      (sum, tax) => sum + parseFloat(tax.amount?.value || 0),
      0
    ),
    total_discount: (prices.discounts || []).reduce(
      (sum, discount) =>
        sum + parseFloat(discount?.amount?.value || 0),
      0
    ),
    coupon_code: cart?.applied_coupons?.[0]?.code ?? "",
    applied_store_credit:
      cart?.applied_store_credit?.applied_balance?.value ?? 0,
  };

  const items =
    cart?.itemsV2?.items?.map((item) => ({
      ...item,
      id: cart.id,
    })) || [];

  return {
    items,
    totals,
  };
};

export const doFetchTotalAmt = async () => {
  const query = `
   query GetCustomerCartTotals {
     customerCart {
       id
       shipping_addresses {
        selected_shipping_method{
          carrier_code
          carrier_title
          method_code
          method_title
          amount{
            value
            currency
          }
        }
        country {
          code
        }
        region {
          code
        }
        postcode
      }
      applied_store_credit {
        applied_balance {
            currency
            value
        }
        current_balance {
            currency
            value
        }
        enabled
      }
       prices {       
         grand_total {
           value
           currency
         }
         subtotal_excluding_tax {
           value
           currency
         }
         subtotal_including_tax {
           value
           currency
         }
         applied_taxes {
           label
           amount {
             value
             currency
           }
         }
         discounts {
           label
           amount {
             value
             currency
           }
         }
       }
     }
   }
 `;
  const response = await wrapGqlRequest(query, {}, "customerCart");
  const prices = response?.prices || {};
  const appliedStoreCredit = response?.applied_store_credit || {};

  const shippingAddress = response.shipping_addresses
    ? response.shipping_addresses[0]
    : {};
  const totals = {
    grand_total: prices.grand_total?.value || 0,
    subtotal_excluding_tax: prices.subtotal_excluding_tax?.value || 0,
    subtotal_including_tax: prices.subtotal_including_tax?.value || 0,
    applied_taxes: (prices.applied_taxes || []).map((tax) => ({
      label: tax.label,
      amount: tax.amount?.value || 0,
    })),
    discounts: (prices.discounts || []).map((discount) => ({
      label: discount.label,
      amount: discount.amount?.value || 0,
    })),
    currency: prices.grand_total?.currency || "USD",
    shipping: shippingAddress?.selected_shipping_method?.amount?.value ?? 0,
    totalTax: (prices.applied_taxes || []).reduce((sum, tax) => {
      return sum + parseFloat(tax.amount.value);
    }, 0),
    total_discount: (prices.discounts || [])?.reduce((sum, discount) => {
      return sum + parseFloat(discount?.amount?.value);
    }, 0),
    coupon_code:
      (prices.discounts || [])?.map((discount) => discount.label)[0] ?? "",
    discount_code: (prices?.discounts || [])?.map(
      (discount) => discount.label,
    )[0]
      ? `${(prices.discounts || [])?.map((discount) => discount.label)[0]}`
      : "",
    applied_store_credit: appliedStoreCredit?.applied_balance?.value ?? 0,
  };

  return totals;
};

export const doDeleteCartProduct = async (itemUid, guoteId) => {
  const mutation = `mutation RemoveItemFromCart($cartId: String!, $cartItemUid: ID) {
  removeItemFromCart(
    input: {
      cart_id: $cartId
      cart_item_uid: $cartItemUid
    }
  )
 {
  cart {
  id
  }
 }
 }
`;
  const variables = {
    cartId: guoteId,
    cartItemUid: itemUid?.productId ?? itemUid,
  };

  const response = await wrapGqlRequest(
    mutation,
    variables,
    "removeItemFromCart",
  );
  // To check if a value exists (is not null or undefined), you can use:
  /*const isUidPresent = response?.cart.itemsV2.items.some(
    (item) => item?.uid === itemUid,
  );
  return !isUidPresent;*/
  return true
};

export const doPutCartItem = async (
  sku,
  qty,
  quoteId,
  itemId,
  ccid,
  price,
  personalizeDetails,
) => {
  const result = await doDeleteCartProduct(itemId, quoteId);
  if (!result) throw new Error("Unable to Update the Cart");
  const mutation = addToCartRequestMutation();
  const variables = {
    cartId: quoteId,
    cartItems: [
      {
        sku: sku,
        quantity: parseFloat(qty),
      },
    ],
  };

  const response = await wrapGqlRequest(
    mutation,
    variables,
    "addProductsToCart",
  );
  return response?.cart;
};

// export const doFetchCoupon = wrapRequest(() => {
//     const requestOptions = {
//         method: 'GET',
//         headers: {
//             'Content-type': 'application/json',
//             'Access-Control-Allow-Origin': '*',
//             ...authHeader()
//         }
//     };
//     return fetch(`${vueAppMagenotApiUrl}/rest/V2/carts/mine/coupons`, requestOptions)
// });
const updateCartItemsMutation = () => {
  return `mutation UpdateCartItems($cartId: String!, $cartItems: [CartItemUpdateInput!]!){
  updateCartItems(input: { cart_id: $cartId, cart_items: $cartItems }) {
    cart {
     ...CART_FRAGMENT
    }
    errors {
      code
      message
    }
  }
}
 fragment CART_FRAGMENT on Cart {
  id
}
`;
};
export const doQtyUpdateCartItem = async ({
  qty,
  quoteId,
  itemId,
  customizableOptions,
}) => {
  const mutation = updateCartItemsMutation();
  const cartItem = {
    cart_item_uid: itemId,
    quantity: parseFloat(qty),
  };
  if (customizableOptions && customizableOptions.length > 0) {
    cartItem.customizable_options = customizableOptions;
  }
  const variables = {
    cartId: quoteId,
    cartItems: [cartItem],
  };

  const response = await wrapGqlRequest(mutation, variables, "updateCartItems");
  return response?.cart;
};
export const doFetchCoupon = async (quoteId) => {
  const query = `
    query FetchCoupons($cartId: String!) {
     cart(cart_id: $cartId) {
       applied_coupons {
         code
       }
     }
    }
  `;
  const variables = {
    cartId: quoteId,
  };
  const response = await wrapGqlRequest(query, variables, "cart");

  if (response?.errors && response?.errors?.length > 0) {
    return {
      message: response.errors[0].message,
    };
  }

  const coupons = response?.applied_coupons?.map((coupon) => coupon.code) || [];
  return coupons;
};

// export const doApplyDiscountCode = wrapRequest((code) => {
//     const requestOptions = {
//         method: 'POST',
//         headers: {
//             'Content-type': 'application/json',
//             'Access-Control-Allow-Origin': '*',
//             ...authHeader()
//         },
//         body: JSON.stringify({
//             "couponCodes": [code]
//         })
//     };
//     return fetch(`${vueAppMagenotApiUrl}/rest/V2/carts/mine/coupons`, requestOptions)
// });
export const doApplyDiscountCode = async (code, quoteId) => {
  const query = `
    mutation ApplyCouponsFromCart($cartId: String!, $code: [String]!, $type: ApplyCouponsStrategy) {
     applyCouponsToCart(input: { cart_id: $cartId, coupon_codes: $code, type: $type }) {
       cart {
         applied_coupons {
           code
         }
       }
     }
    }
  `;
  const variables = {
    cartId: quoteId,
    code: [code],
    type: "APPEND",
  };
  const response = await wrapGqlRequest(query, variables, "applyCouponsToCart");

  if (response?.errors && response?.errors?.length > 0) {
    return {
      message: response.errors[0].message,
    };
  }

  const appliedCoupons = response?.cart?.applied_coupons || [];
  console.log(`appliedCoupons: ${appliedCoupons}`);
  if (appliedCoupons.length > 0) {
    return true;
  }

  return {
    message: "No coupon applied.",
  };
};

// export const doRemoveDiscountCode = wrapRequest((code) => {
//     const requestOptions = {
//         method: 'POST',
//         headers: {
//             'Content-type': 'application/json',
//             'Access-Control-Allow-Origin': '*',
//             ...authHeader()
//         },
//         body: JSON.stringify({
//             "couponCodes": [code]
//         })
//     };
//     return fetch(`${vueAppMagenotApiUrl}/rest/V2/carts/mine/coupons/deleteByCodes`, requestOptions)
// });
export const doRemoveDiscountCode = async (code, quoteId) => {
  const query = `
    mutation RemoveCouponsFromCart($cartId: String!, $code: [String]!) {
     removeCouponsFromCart(input: { cart_id: $cartId, coupon_codes: $code }) {
       cart {
         applied_coupons {
           code
         }
       }
     }
    }
  `;
  const variables = {
    cartId: quoteId,
    code: [code],
  };

  const response = await wrapGqlRequest(
    query,
    variables,
    "removeCouponsFromCart",
  );

  if (response?.errors && response?.errors?.length > 0) {
    return {
      message: response.errors[0].message,
    };
  }

  const appliedCoupons = response?.cart?.applied_coupons || [];
  if (!appliedCoupons.includes(code)) {
    return true;
  }

  return {
    message: "Coupon could not be removed.",
  };
};

// export const doFetchGiftMessage = wrapRequest((quoteId, itemId) => {
//   const requestOptions = {
//     method: "GET",
//     headers: {
//       "Content-type": "application/json",
//       "Access-Control-Allow-Origin": "*",
//       ...authHeader(),
//     },
//   };
//   return fetch(
//     `${vueAppMagenotApiUrl}/rest/V1/item/data?itemId=${itemId}&cartid=${quoteId}`,
//     requestOptions
//   );
// });
export const doFetchGiftMessage = wrapRequest(async (quoteId, itemId) => {
  const response = await doFetchCartProducts(quoteId);
  const result = response?.filter((item) => {
    return item?.uid === itemId;
  });
  return { ok: true, items: result };
});

export const doPutCraneConectionCartItem = wrapRequest(
  async ({ sku, qty, itemId, userQuote, productOption }) => {
    const res = await doDeleteCartProduct(itemId, userQuote);
    if (!res) throw new Error("Unable to Update the Cart");

    const query = addToCartRequestMutation();
    let uid =
      productOption?.extension_attributes?.custom_options?.[0].option_id;
    uid = typeof uid === "number" ? btoa(`custom-option/${uid}`) : uid;
    const ccId =
      productOption?.extension_attributes?.custom_options?.[0].option_value;
    const variables = {
      cartId: userQuote,
      cartItems: [
        {
          sku: sku,
          quantity: parseFloat(qty) ?? 0.0,
          entered_options: [
            {
              uid: uid ?? "",
              value: ccId ?? "",
            },
          ],
        },
      ],
    };
    const response = await wrapGqlRequest(
      query,
      variables,
      "addProductsToCart",
    );
    return response?.cart;
  },
);

export const doPostCraneConnectionCartItem = async ({
  sku,
  qty,
  userQuote,
  enteredOptions,
}) => {
  const query = addToCartRequestMutation();
  const variables = {
    cartId: userQuote,
    cartItems: [
      {
        sku: sku,
        quantity: parseFloat(qty) ?? 0.0,
        entered_options: enteredOptions,
      },
    ],
  };
  const response = await wrapGqlRequest(query, variables, "addProductsToCart");
  return response?.cart;
};

const addToCartRequestMutation = () => {
  return `mutation AddProductsToCart($cartId: String!, $cartItems: [CartItemInput!]!) {
  addProductsToCart(cartId: $cartId, cartItems: $cartItems) {
    cart {
      ...CART_FRAGMENT
    }
    user_errors {
      code
      message
    }
  }
}
 fragment CART_FRAGMENT on Cart {
  id
  total_quantity
  is_virtual
  itemsV2 {
    items {
      ...CART_ITEM_FRAGMENT
    }
  }
}

fragment CART_ITEM_FRAGMENT on CartItemInterface {
  __typename
  uid
  quantity
  is_available
  not_available_message
  errors {
    code
    message
  }
  prices {
    price {
      value
      currency
    }
  }
  product {
    name
    sku
    quantity
    stock_status
  }
}
 `;
};

const addGiftCardToCartRequestMutation = () => {
  return `mutation AddProductsToCart($cartId: String!, $cartItems: [CartItemInput!]!) {
  addProductsToCart(cartId: $cartId, cartItems: $cartItems) {
    cart {
      ...CART_FRAGMENT
    }
    user_errors {
      code
      message
    }
  }
}
 fragment CART_FRAGMENT on Cart {
  id
  total_quantity
  is_virtual
  itemsV2 {
    items {
      ...CART_ITEM_FRAGMENT
    }
  }
}

fragment CART_ITEM_FRAGMENT on CartItemInterface {
  __typename
  uid
  quantity
  is_available
  not_available_message
  errors {
    code
    message
  }
  prices {
    price {
      value
      currency
    }
  }
  product {
    name
    sku
    quantity
    stock_status
  }
}
 `;
};

export const checkCartContainsGiftCartProducts = async (cartId) => {
  const query = `query FetchGiftCardCart($cartId: String!) {
    cart(cart_id: $cartId) {
      id
      itemsV2{
        items{
          __typename
        }
      }
    }
  }
  `;
  const variables = { cartId: cartId };
  const cart = await wrapGqlRequest(query, variables, "cart");
  const res = cart?.itemsV2?.items?.filter((item) => {
    return item?.__typename === "GiftCardCartItem";
  });
  return res?.length > 0 ? true : false;
};

export const convertGuestToCustomerCart = async ({
  guestCartId,
  customerCartId,
}) => {
  const mutation = `mutation MergeCarts($source_cart_id: String!, $destination_cart_id: String!) {
    mergeCarts(
        source_cart_id: $source_cart_id
        destination_cart_id: $destination_cart_id
    ) {
        email
        gift_receipt_included
        id
        is_virtual
        printed_card_included
        total_quantity
    }
}

`;
  const variables = {
    source_cart_id: guestCartId,
    destination_cart_id: customerCartId,
  };
  const response = await wrapGqlRequest(mutation, variables, "mergeCarts");

  return response;
};

export const doUpdateCCProductQuantity = wrapRequest(
  ({ orderNumber, quantity }) => {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-type": "application/json",
      },
    };
    return fetch(
      `${vueAppNodeslsApiUrl}/cc-update-cart-item-quantity?orderNumber=${orderNumber}&quantity=${quantity}`,
      requestOptions,
    );
  },
);
